import { render, staticRenderFns } from "./AiDrawer.vue?vue&type=template&id=3f284e2d&scoped=true&"
import script from "./AiDrawer.vue?vue&type=script&lang=js&"
export * from "./AiDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AiDrawer.vue?vue&type=style&index=0&id=3f284e2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f284e2d",
  null
  
)

export default component.exports